export const loadScript = (src: string, async = true): void => {
  const el = document.createElement("script");
  el.type = "text/javascript";
  el.async = async;
  el.src = src;
  const x = document.getElementsByTagName("script")[0];
  x.parentNode?.insertBefore(el, x);
};
